var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7409 24.9688V22.0313H43.0846V24.9688H35.7409ZM38.1888 39.1667L32.2648 34.7605L34.0273 32.4105L39.9513 36.8167L38.1888 39.1667ZM34.1742 14.5407L32.4117 12.1907L38.1888 7.83337L39.9513 10.1834L34.1742 14.5407ZM10.2826 37.2084V29.375H6.85547C6.04766 29.375 5.3562 29.0873 4.7811 28.5119C4.20568 27.9368 3.91797 27.2454 3.91797 26.4375V20.5625C3.91797 19.7547 4.20568 19.0631 4.7811 18.4877C5.3562 17.9126 6.04766 17.625 6.85547 17.625H15.668L25.4596 11.75V35.25L15.668 29.375H13.2201V37.2084H10.2826ZM22.5221 30.0605V16.9396L16.4513 20.5625H6.85547V26.4375H16.4513L22.5221 30.0605ZM27.418 30.0605V16.9396C28.2992 17.723 29.0091 18.6776 29.5477 19.8037C30.0862 20.9297 30.3555 22.1618 30.3555 23.5C30.3555 24.8382 30.0862 26.0704 29.5477 27.1964C29.0091 28.3224 28.2992 29.2771 27.418 30.0605Z",
    fill: "#183A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.634ddd14c8eb5079bee88ad39b70b99a.svg";
export { ForwardRef as ReactComponent };